import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';

import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';

const NUMBER_BADGE_SIZE = 12;

const styles = StyleSheet.create({
  comment: {
    padding: 16,
    marginBottom: 8,
    backgroundColor: '#ededed',
    borderRadius: 6,
  },
  commentTitleWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  numberBadge: {
    width: NUMBER_BADGE_SIZE,
    height: NUMBER_BADGE_SIZE,
    borderRadius: NUMBER_BADGE_SIZE / 2,
    backgroundColor: '#000',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 5,
  },
  numberBadgeText: {
    ...commonStyles.fontXS,
    color: '#fff',
    fontWeight: 'bold',
  },
  commentTitle: {
    ...commonStyles.fontS,
    fontWeight: 'bold',
  },
  commentNote: {
    ...commonStyles.fontS,
  },
  commentNumeration: {
    ...commonStyles.fontS,
  },
});

function PointBubble({ point, orderIndex, projectionIdx, width }) {
  const { t } = useTranslation('specification');

  return (
    <View style={[styles.comment, { width }]} wrap={false}>
      <View style={styles.commentTitleWrapper}>
        <View style={styles.numberBadge}>
          <Text style={styles.numberBadgeText}>{orderIndex + 1}</Text>
        </View>
        <Text style={styles.commentTitle}>{point?.componentName}</Text>
      </View>
      <Text style={styles.commentNote}>{point.note}</Text>
      <Text style={styles.commentNumeration}>
        {point.photo ? `${t('drawing')} ${projectionIdx}.${point.photoNumber}` : ''}
      </Text>
    </View>
  );
}

export default PointBubble;
